import type { Room } from "@workspace/livekit/client"

const CHUNK_SIZE = 15000
const TOOLS_SCHEMA_TOPIC = "tools:schema"

function _chunkString(value: string, chunkSize: number) {
  if (value.length <= chunkSize) return [value]

  const chunks: string[] = []
  for (let i = 0; i < value.length; i += chunkSize) {
    chunks.push(value.slice(i, i + chunkSize))
  }
  return chunks
}

async function _writeToolsSchema(room: Room, toolsSchema: unknown) {
  const payload = JSON.stringify(toolsSchema)
  const streamWriter = await room.localParticipant.streamText({
    topic: TOOLS_SCHEMA_TOPIC,
  })

  try {
    const textChunks = _chunkString(payload, CHUNK_SIZE)
    for (const chunk of textChunks) {
      await streamWriter.write(chunk)
    }
  } finally {
    await streamWriter.close()
  }
}

export function streamTools(room: Room, toolsSchema: unknown) {
  if (room.state !== "connected") return

  void _writeToolsSchema(room, toolsSchema).catch((error) => {
    console.error("Error streaming tools schema:", error)
  })
}
